// Opens the Chatwoot chat window directly (instead of only showing the bubble).
// If ChatwootWidget is still loading the SDK, waits for it to be ready first.
export const openChatwootWindow = () => {
  if (window.$chatwoot?.hasLoaded) {
    window.$chatwoot.toggle("open");
    return;
  }
  window.addEventListener(
    "chatwoot:ready",
    // setTimeout lets ChatwootWidget's own ready listener (setChatwootUser) run first
    () => setTimeout(() => window.$chatwoot?.toggle("open"), 0),
    { once: true }
  );
};
